import React from "react";
import Header from "./Header";
import About from "./About";
import Main from "./Main";
import Product from "./Product";
import Footer from "./Footer";

function Home(){
    return(
        <>
        <Header></Header>
        <Main></Main>
        <Footer></Footer>
        </>
    );
};

export default Home